import { createNavigationContainerRef } from '@react-navigation/native'
import type { ParamListBase } from '@react-navigation/native'

export const navigationRef = createNavigationContainerRef<ParamListBase>()

export const navigate = (name: string, params?: Record<string, unknown>): void => {
  if (!navigationRef.isReady()) return
  ;(navigationRef as unknown as { navigate: (n: string, p?: Record<string, unknown>) => void })
    .navigate(name, params)
}

export const goBack = (): void => {
  if (!navigationRef.isReady()) return
  if (!navigationRef.canGoBack()) return
  navigationRef.goBack()
}
